module.exports = __webpack_public_path__ + "img/word-file.bbeabacb.svg";